import React, { useState } from "react";
import { useFormikContext } from "formik";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import {
  CustomOutlinedDisabledCurrencyField,
  CustomOutlinedDisabledTextField,
} from "../../../../../partials/content/Forms";
import {
  FormDateField,
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { formatDate } from "../../../../../utils/utils";
import { DialogActions } from "@material-ui/core";
import SearchGlAccount from "../../../setup/finance/searchGlAccount";
import { Card, Badge } from "react-bootstrap";
function DisposalAssetFormContent(props) {
  const { values, setFieldValue } = useFormikContext();
  const [openSearchGlAccount, setOpenSearchGlAccount] = useState(false);
  const [accountTypeID, setAccountTypeID] = useState(0);
  const disposalTypeOptions = [];
  disposalTypeOptions.push({
    label: "Scrap",
    value: 1,
  });
  disposalTypeOptions.push({
    label: "Sell",
    value: 2,
  });
  if (values.disposalStatus === 1 && values.depreciationStatus === 1) {
    disposalTypeOptions.push({
      label: "Reversal",
      value: 3,
    });
  }
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-window-maximize"></i>
              <span>
                <strong>Asset Header</strong>
              </span>
              {values.ID !== "" ? (
                <React.Fragment>
                  <Badge
                    className="float-right ml-1"
                    variant={
                      values.depreciationStatus === 3
                        ? "danger"
                        : values.depreciationStatus === 2
                        ? "warning"
                        : values.depreciationStatus === 1
                        ? "success"
                        : null
                    }
                  >
                    {values.depreciationStatus !== 0
                      ? "Asset " + values.depreciationStatusDesc
                      : null}
                  </Badge>
                  <Badge
                    className="float-right ml-1"
                    variant={
                      values.disposalStatus === 3
                        ? "danger"
                        : values.disposalStatus === 2
                        ? "warning"
                        : values.disposalStatus === 1
                        ? "success"
                        : null
                    }
                  >
                    {values.disposalStatus !== 0
                      ? "Asset " + values.disposalStatusDesc
                      : null}
                  </Badge>
                </React.Fragment>
              ) : null}
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormTextField
                    label="Asset Code"
                    name="assetCode"
                    iconField
                    iconOnStart={
                      values.itemType === 1
                        ? "fas fa-boxes"
                        : values.itemType === 2
                        ? "fas fa-tools"
                        : values.itemType === 3
                        ? "fas fa-building"
                        : values.itemType === 4
                        ? "fas fa-boxes"
                        : values.itemType === 5
                        ? "fas fa-boxes"
                        : ""
                    }
                    iconOnStartColor={
                      values.itemType === 1
                        ? "success"
                        : values.itemType === 2
                        ? "primary"
                        : values.itemType === 3
                        ? "info"
                        : values.itemType === 4
                        ? "warning"
                        : values.itemType === 5
                        ? "danger"
                        : ""
                    }
                    iconOnStartTooltip={values.itemTypeName}
                    readonly
                  />
                  <FormTextField label="Asset Name" name="itemName" readonly />
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Purchase Date"
                        value={formatDate(values.purchaseDate)}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Received Date"
                        value={formatDate(values.receivedDate)}
                      />
                    </div>
                  </div>
                  {values.assetOriginType === 1 ? (
                    <FormTextField
                      label="Vendor Name"
                      name="vendorName"
                      readonly
                    />
                  ) : null}
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormTextField
                    label="Asset Origin"
                    name="assetOriginTypeName"
                    readonly
                  />
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Stock Quantity"
                        name="qtyStock"
                        readonly
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField label="Unit" name="uomName" readonly />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledCurrencyField
                        label="Unit Asset Value"
                        value={values.unitValueAmount}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledCurrencyField
                        label="Total Asset Value"
                        value={values.unitValueAmount * values.qtyStock}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <FormTextField
                    label="Asset Description"
                    name="assetDesc"
                    readonly
                    multiline
                    minRows={2}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-trash-alt"></i>
              <span>
                <strong>Asset Disposal</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormSelectField
                    label="Disposal Type"
                    name="disposalType"
                    options={disposalTypeOptions}
                    onSelectChange={(value) => {
                      if (value === 3) {
                        setFieldValue("qty", values.qtyStock);
                        setFieldValue("unitPrice", values.unitValueAmount);
                        setFieldValue(
                          "totalPrice",
                          values.unitValueAmount * values.qtyStock
                        );
                        setFieldValue("gainAssetDisposal", 0);
                        setFieldValue(
                          "totalAssetValue",
                          values.unitValueAmount * values.qtyStock
                        );
                      } else {
                        setFieldValue("qty", 0);
                        setFieldValue("unitPrice", 0);
                        setFieldValue("totalPrice", 0);
                        setFieldValue("gainAssetDisposal", 0);
                        setFieldValue("totalAssetValue", 0);
                      }
                    }}
                  />
                  <FormDateField label="Disposal Date" name="disposalDate" />
                  <FormTextField
                    label="Expense Account"
                    name="exAccountName"
                    onSearchClick={() => {
                      setAccountTypeID(10);
                      setOpenSearchGlAccount(true);
                    }}
                    onClearFields={() => {
                      setFieldValue(`exAccountID`, 0);
                      setFieldValue(`exAccountName`, "");
                    }}
                    readonly
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Disposal Quantity"
                        name="qty"
                        quantityField
                        readonly={values.disposalType === 3 ? true : false}
                        onChangeValue={(value) => {
                          const qty = parseFloat(value);
                          const unitPrice = parseFloat(values.unitPrice);
                          const totalUnitDepAmount = parseFloat(
                            values.totalUnitDepAmount
                          );
                          const totalDepAmount = totalUnitDepAmount * qty;
                          const unitValueAmount = parseFloat(
                            values.unitValueAmount
                          );
                          const totalAssetValue = qty * unitValueAmount;
                          const totalSellPrice = unitPrice * qty;
                          setFieldValue("totalPrice", totalSellPrice);
                          setFieldValue("totalAssetValue", totalAssetValue);
                          setFieldValue("totalDepAmount", totalDepAmount);
                          if (values.disposalType === 1) {
                            let unDepAmount = 0;
                            if (totalDepAmount > 0) {
                              unDepAmount = totalAssetValue;
                            } else {
                              unDepAmount = totalAssetValue;
                            }
                            setFieldValue(
                              "gainAssetDisposal",
                              unDepAmount * -1
                            );
                          } else {
                            setFieldValue(
                              "gainAssetDisposal",
                              totalSellPrice - totalAssetValue
                            );
                          }
                        }}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Total Disposal Asset Value"
                        name="totalAssetValue"
                        currencyField
                        readonly
                      />
                    </div>
                  </div>
                  {values.disposalType === 2 || values.disposalType === 3 ? (
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <FormTextField
                          label="Unit Sell Price"
                          name="unitPrice"
                          currencyField
                          readonly={values.disposalType === 3 ? true : false}
                          onChangeValue={(value) => {
                            const unitPrice = parseFloat(value);
                            const qty = parseFloat(values.qty);
                            const unitValueAmount = parseFloat(
                              values.unitValueAmount
                            );
                            const totalAssetValue = qty * unitValueAmount;
                            const totalSellPrice = unitPrice * qty;
                            setFieldValue("totalPrice", totalSellPrice);
                            setFieldValue("totalAssetValue", totalAssetValue);
                            setFieldValue(
                              "gainAssetDisposal",
                              totalSellPrice - totalAssetValue
                            );
                          }}
                        />
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <FormTextField
                          label="Total Sell Price"
                          name="totalPrice"
                          currencyField
                          readonly
                        />
                      </div>
                    </div>
                  ) : null}
                  <FormTextField
                    label={`${
                      values.gainAssetDisposal > 0 ? "Gain" : "Loss"
                    } on Asset Disposal`}
                    name="gainAssetDisposal"
                    currencyField
                    readonly
                  />
                  {values.disposalType === 2 || values.disposalType === 3 ? (
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <FormTextField
                          label="Revenue Account"
                          name="revAccountName"
                          onSearchClick={() => {
                            setAccountTypeID(6);
                            setOpenSearchGlAccount(true);
                          }}
                          onClearFields={() => {
                            setFieldValue(`revAccountID`, 0);
                            setFieldValue(`revAccountName`, "");
                          }}
                          readonly
                        />
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <FormTextField
                          label="Cash Account"
                          name="cashAccountName"
                          onSearchClick={() => {
                            setAccountTypeID(1);
                            setOpenSearchGlAccount(true);
                          }}
                          onClearFields={() => {
                            setFieldValue(`cashAccountID`, 0);
                            setFieldValue(`cashAccountName`, "");
                          }}
                          readonly
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <DialogLayout
        open={openSearchGlAccount}
        title="Search GL Account"
        onCloseDialog={() => {
          setOpenSearchGlAccount(false);
        }}
        maxWIdth="md"
      >
        <SearchGlAccount
          accountTypeID={accountTypeID}
          onSelectGlAccount={(account) => {
            switch (accountTypeID) {
              case 1:
                setFieldValue(`cashAccountID`, account.ID);
                setFieldValue(`cashAccountName`, account.accountName);
                break;
              case 6:
                setFieldValue(`revAccountID`, account.ID);
                setFieldValue(`revAccountName`, account.accountName);
                break;
              case 10:
                setFieldValue(`exAccountID`, account.ID);
                setFieldValue(`exAccountName`, account.accountName);
                break;
              default:
                break;
            }

            setOpenSearchGlAccount(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchGlAccount(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default DisposalAssetFormContent;
